import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { toast } from "sonner";
import { Archive, Download, PlayCircle, Loader2 } from "lucide-react";
import { fmtDateTime } from "../lib/utils-app";

export default function BackupsPanel() {
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(false);

  const load = async () => { const { data } = await api.get("/admin/backups"); setItems(data); };
  useEffect(() => { load(); }, []);

  const runNow = async () => {
    setBusy(true);
    try {
      await api.post("/admin/backups/run");
      toast.success("Backup avviato: riceverai un'email al termine. La lista si aggiorna tra pochi secondi.");
      setTimeout(load, 8000); setTimeout(load, 20000);
    } catch { toast.error("Errore avvio backup"); }
    finally { setBusy(false); }
  };

  const download = async (b) => {
    try {
      const res = await api.get(`/admin/backups/${b.id}/download`, { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/zip" }));
      const a = document.createElement("a"); a.href = url; a.download = b.filename; a.click();
      window.URL.revokeObjectURL(url);
    } catch { toast.error("Errore download"); }
  };

  return (
    <section className="space-y-3" data-testid="backups-panel">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <h2 className="font-display text-lg font-semibold text-slate-900 flex items-center gap-2"><Archive size={18} /> Backup documenti</h2>
          <p className="text-sm text-slate-500">Ogni domenica alle 03:00 viene generato un archivio ZIP di tutti i documenti e inviato via email agli admin.</p>
        </div>
        <button onClick={runNow} disabled={busy} data-testid="run-backup"
          className="inline-flex items-center gap-2 border border-slate-300 hover:bg-slate-50 px-3 py-2 rounded-lg text-sm font-medium">
          {busy ? <Loader2 size={16} className="animate-spin" /> : <PlayCircle size={16} />} Esegui backup ora
        </button>
      </div>
      <div className="overflow-x-auto border border-slate-200 rounded-lg bg-white">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-600">
            <tr>
              <th className="text-left px-4 py-3 font-medium">Data</th>
              <th className="text-left px-4 py-3 font-medium">File</th>
              <th className="text-left px-4 py-3 font-medium">Documenti</th>
              <th className="text-left px-4 py-3 font-medium">Dimensione</th>
              <th className="text-left px-4 py-3 font-medium">Origine</th>
              <th className="text-right px-4 py-3 font-medium">Azioni</th>
            </tr>
          </thead>
          <tbody>
            {items.map(b => (
              <tr key={b.id} className="border-t border-slate-100 hover:bg-slate-50" data-testid="backup-row">
                <td className="px-4 py-3 text-xs">{fmtDateTime(b.created_at)}</td>
                <td className="px-4 py-3 font-mono text-xs">{b.filename}</td>
                <td className="px-4 py-3">{b.doc_count}</td>
                <td className="px-4 py-3">{(b.size / 1024 / 1024).toFixed(2)} MB</td>
                <td className="px-4 py-3 text-xs text-slate-500">{b.triggered_by === "cron" ? "Automatico" : b.triggered_by}</td>
                <td className="px-4 py-3 text-right">
                  <button onClick={() => download(b)} data-testid={`download-backup-${b.id}`} className="text-blue-700 p-1.5" title="Scarica"><Download size={16} /></button>
                </td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={6} className="p-6 text-center text-slate-500">Nessun backup ancora eseguito.</td></tr>}
          </tbody>
        </table>
      </div>
    </section>
  );
}
